export default {
	"components.WeChat": "微信",
	"components.Alipay": "支付寶",
	"components.ScanCodeToPay": "後掃碼支付",
	"components.SaveQRCode": "保存二維碼",
	"components.detectedThatYouAreNotInstalled": "檢測到您未安裝",
	"components.PleaseInstall": "，請安裝"
}